var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfrainstractureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.244,
    height: 17.262,
    viewBox: "0 0 15.244 15.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(-257 -248.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M166.07,311.5c0-.042.006-.084.006-.126V301.1a.71.71,0,0,0,0-.075c-.007-.059.019-.082.077-.075a.562.562,0,0,0,.06,0h10.319a.2.2,0,0,1,.074,0,.105.105,0,0,1,.053.053.2.2,0,0,1,0,.074v10.305c0,.039,0,.079.006.118Zm.625-5.257V310.8c0,.117,0,.117.114.117h9.118c.114,0,.114,0,.114-.116v-9.118c0-.116,0-.116-.114-.116H166.81c-.115,0-.115,0-.115.116Z",
    transform: "translate(90.93 -47.99)",
    fill: "#29a19c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M377.951,299.94l2.095,2.336c-.041,0-.067,0-.092,0h-1.3c-.073,0-.091.023-.091.093v5.581c0,.1,0,.1.1.1h1.384l-2.1,2.34-2.093-2.336c.05,0,.078-.005.105-.005h1.276c.1,0,.1,0,.1-.1v-5.574c0-.075-.019-.1-.1-.1-.43,0-.861,0-1.291,0h-.1C376.559,301.493,377.254,300.718,377.951,299.94Z",
    transform: "translate(-107.805 -47.037)",
    fill: "#29a19c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M171.393,211.54v1.381c0,.1,0,.105.105.105h5.566c.1,0,.105,0,.105-.105v-1.313c0-.016,0-.033.005-.064l2.327,2.089-2.326,2.091c0-.036-.006-.057-.006-.077v-1.305c0-.093,0-.1-.1-.1H171.5c-.1,0-.105,0-.105.105v1.383l-.078-.066-1.236-1.11q-.482-.434-.966-.865c-.046-.041-.041-.069,0-.105q.651-.579,1.3-1.162c.289-.258.575-.52.863-.779C171.31,211.608,171.345,211.581,171.393,211.54Z",
    transform: "translate(88.078 36.708)",
    fill: "#29a19c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrainstractureIcon);
export default __webpack_public_path__ + "static/media/InfrainstractureIcon.940ef2f77b13a2fdc888e6b02c9417d2.svg";
export { ForwardRef as ReactComponent };